import { memo } from 'react';

import { type SearchSavedFiltersResponse } from '@air/api/types';
import { useCommandState } from '@air/cmdk';

import { SearchCommandGroup } from '~/components/SearchCommand/SearchCommandGroup';
import { SearchCommandSavedFilterListItem } from '~/components/SearchCommand/SearchCommandSavedFilterListItem';

export type SearchCommandSavedFilterListProps = {
  onSelect: (savedFilter: SearchSavedFiltersResponse) => void;
  savedFilters: SearchSavedFiltersResponse[];
};

export const SearchCommandSavedFilterList = memo(({ savedFilters, onSelect }: SearchCommandSavedFilterListProps) => {
  const search = useCommandState((state) => state.search);

  return (
    <SearchCommandGroup heading={search ? 'Saved searches' : 'Recent saved searches'}>
      {savedFilters.map((savedFilter) => (
        <SearchCommandSavedFilterListItem key={savedFilter.id} savedFilter={savedFilter} onSelect={onSelect} />
      ))}
    </SearchCommandGroup>
  );
});

SearchCommandSavedFilterList.displayName = 'SearchCommandSavedFilterList';
